import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
          localizable: require('./locales/en/localizable.json'),
          enrollment: require('./locales/en/enrollment.json'),
          generic: require('./locales/en/generic.json'),
          mood: require('./locales/en/mood.json'),
          respiratory: require('./locales/en/respiratory.json'),
          voice: require('./locales/en/voice.json'),
          neurology: require('./locales/en/neurology.json'),
      },
      'es-419': {
          localizable: require('./locales/es-419/localizable.json'),
          enrollment: require('./locales/es-419/enrollment.json'),
          generic: require('./locales/es-419/generic.json'),
          mood: require('./locales/es-419/mood.json'),
          respiratory: require('./locales/es-419/respiratory.json'),
          voice: require('./locales/es-419/voice.json'),
          neurology: require('./locales/es-419/neurology.json'),
      }
    },
    lng: 'en', // default language
    fallbackLng: 'en',
    ns: ['localizable', 'enrollment', 'generic', 'mood', 'respiratory', 'voice', 'neurology'],
    defaultNS: 'localizable',
    fallbackNS: 'localizable',
    interpolation: { escapeValue: false }
  });

export default i18n;
